import { BaseService } from "./base.service";
import {
	ISystemTemplateType,
	ITemplateTypeGridDetail,
	ITemplateTypeNumber,
} from "models/TemplateType/TemplateTypeModel";
import { TableFilterModel } from "models/TableFilterModel";
import { TemplateTypeDetailModel } from "models/TemplateType/TemplateTypeDetailModel";
import { ITableNumberColumnFilter } from "models/TableNumberColumnFilter";

class TemplateTypeServiceInternal extends BaseService {
	getSystemTemplateTypeList = async (): Promise<ISystemTemplateType[]> =>
		this.callApi<ISystemTemplateType[]>(
			`SystemTemplateType/GetSystemTemplateTypeList`,
			"GET"
		);

	getSystemTemplateTypeGridList = async (
		model: TableFilterModel
	): Promise<ITemplateTypeGridDetail[]> =>
		this.callApi<ITemplateTypeGridDetail[]>(
			`SystemTemplateType/GetSystemTemplateTypeList`,
			"POST",
			undefined,
			model
		);

	getSystemTemplateTypeNumberList = async (
		model: ITableNumberColumnFilter
	): Promise<ITemplateTypeNumber[]> =>
		this.callApi<ITemplateTypeNumber[]>(
			`SystemTemplateType/GetSystemTemplateTypeNumberList`,
			"POST",
			undefined,
			model
		);

	saveSystemTemplateType = async (
		model: TemplateTypeDetailModel
	): Promise<{ systemTemplateTypeId: number; typeNumber: string }> =>
		this.callApi<{ systemTemplateTypeId: number; typeNumber: string }>(
			`SystemTemplateType/Save`,
			"POST",
			undefined,
			model
		);

	updateSystemTemplateType = async (
		model: TemplateTypeDetailModel
	): Promise<{ systemTemplateTypeId: number; typeNumber: string }> =>
		this.callApi<{ systemTemplateTypeId: number; typeNumber: string }>(
			`SystemTemplateType/Update/${model.systemTemplateTypeId}`,
			"PUT",
			undefined,
			model
		);

	deleteSystemTemplateType = async (
		systemTemplateTypeId: number
	): Promise<undefined> =>
		this.callApi<undefined>(
			`SystemTemplateType/Delete/${systemTemplateTypeId}`,
			"DELETE"
		);

	getSystemTemplateTypeDetail = async (
		systemTemplateTypeId: number
	): Promise<TemplateTypeDetailModel> =>
		this.callApi<TemplateTypeDetailModel>(
			`SystemTemplateType/GetById/${systemTemplateTypeId}`,
			"GET"
		);

	checkSystemTemplateTypeAlreadyUsed = async (
		systemTemplateTypeId: number
	): Promise<{ isAlreadyUsed: boolean }> =>
		this.callApi<{ isAlreadyUsed: boolean }>(
			`SystemTemplateType/CheckSystemTemplateTypeAlreadyUsed/${systemTemplateTypeId}`,
			"GET"
		);
}

export const TemplateTypeService = new TemplateTypeServiceInternal();
